module.exports = __webpack_public_path__ + "media/B-A-005_SAF_BTB_IncidentResponse.bb390990.mp4";